import { request } from ".."

export function postPurchase(purchase) {
    return request({ url: "purchases/", data: purchase, method: "POST" })
}

export function getAllPurchases(params = {}){
    return request({"url": `purchases/`, method:"GET", params})
}

export function putPurchase(id, purchase){
    return request({ url: `purchases/${id}/confirm/`, data: purchase, method: "PUT" })
}


// WEBPACK FOOTER //
// ./src/api/purchases/index.js